/** True when the URL points to a PDF (query string ignored): PDFs are previewed in an `<object>`, not an `<img>`. */
export const isPdfUrl = (url: string): boolean => url.toLowerCase().split(/[?#]/)[0].endsWith('.pdf');
